import { render, staticRenderFns } from "./MyOrderImport.vue?vue&type=template&id=124b3676&scoped=true"
import script from "./MyOrderImport.vue?vue&type=script&lang=js"
export * from "./MyOrderImport.vue?vue&type=script&lang=js"
import style0 from "./MyOrderImport.vue?vue&type=style&index=0&id=124b3676&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124b3676",
  null
  
)

export default component.exports